import React, {useEffect} from "react";
import { connect } from "react-redux"
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "../../routes";
import { runCompanyDataValidation } from "../../store/modules/appState/actions"
import { Toaster } from "react-hot-toast";

const App = ({ dispatchRunCompanyDataValidation }) => {
  useEffect(() => {
    dispatchRunCompanyDataValidation()
  }, [])

  return (
    <div className="App">
      <Router>
        <Routes />
      </Router>
      <Toaster
      
      />
    </div>
  );
};


const mapDispatchToProps = (dispatch) => ({
  dispatchRunCompanyDataValidation() {
    dispatch(runCompanyDataValidation())
  }
})

export default connect(null, mapDispatchToProps)(App)
